import React from 'react';
import CoverImage from './CoverImage';
import Gallery2 from './Gallery2';
import Footer from './Footer';

const Gallery = () => {
    return (
        <div>

            <CoverImage/>
            <Gallery2/>
        
        </div>
    );
};

export default Gallery;